import { useEffect, useState } from 'react'
import Slides from '../slides/Slides'
import Modal from './Modal';
import { WebService } from '../../services/webService';
import Swal from 'sweetalert2';

const Blog = ({M}) => {
   const [blogWhite,setBlogWhite]   = useState();
   const [blogBlue, setBlogBlue]    = useState();
   const [blogMonth, setBlogMonth]  = useState();
   const [modal, setModal]          = useState();
   
   const getBlog = async () => {
      try {
         const data = await WebService.getBlog();
         setBlogWhite(data.blogWhite || []);
         setBlogBlue(data.blogBlue || []);
         setBlogMonth(data.blogMonth || []);
      } catch (error) {
         Swal.fire({
            icon: "error",
            title: "Error!",
            text: "No se pudieron cargar los datos del blog",
            confirmButtonColor: "#147B9C",
         });
      }
   };

   const handleModalBlog = async (blog_id) => {
   try {
      const data = await WebService.getBlogByID(blog_id);
      setModal(data);
   } catch (error) {
      Swal.fire({
         icon: "error",
         title: "Error!",
         text: "No se pudo cargar la información del blog",
         confirmButtonColor: "#147B9C",
      });
   }
   };

   useEffect(() => {
      getBlog();
      let collapsible = document.querySelectorAll(".collapsible");
      M.Collapsible.init(collapsible);

      let modal = document.querySelectorAll(".modal-blog");
      M.Modal.init(modal);
   }, []);
   return (
      <>
         <Slides M={M} tipoSlides={"blog"}/>
         <div className="section animated fadeIn" style={{ padding: '30px 0' }}>
            <div className="container" style={{ width: '100%', maxWidth: '1300px' }}>
               <div className="row">
                  
                  {/* COLUMNA IZQUIERDA - LISTADO PRINCIPAL (BLANCO) */}
                  <div className="col s12 m12 l8 xl8">
                     <div className='scroll'>
                     <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        {blogWhite?.map((bw, index) => {
                           return (
                              <div className="card horizontal hoverable" key={index} style={{ borderRadius: '12px', overflow: 'hidden', border: '1px solid #e0e0e0', margin: 0, boxShadow: '0 2px 10px rgba(0,0,0,0.05)', display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                                 
                                 {/* IMAGEN CON ETIQUETA */}
                                 <div className="col s12 m4 l4 xl4" style={{ padding: 0, position: 'relative', minHeight: '200px' }}>
                                    <img 
                                       src={`/app.latitud/img/blog/${bw.blog_img}`} 
                                       alt={bw.blog_titulo} 
                                       style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', position: 'absolute', top: 0, left: 0 }}
                                    />
                                    <span className="etiqueta" style={{ position: 'absolute', top: '10px', left: '10px', background: '#039be5', color: '#fff', padding: '4px 10px', borderRadius: '4px', fontSize: '0.75rem', fontWeight: '600', textTransform: 'uppercase', zIndex: '2' }}>
                                       {bw.blog_etiqueta}
                                    </span>
                                 </div>

                                 {/* CONTENIDO APILADO */}
                                 <div className="col s12 m8 l8 xl8" style={{ padding: 0, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                    <div className="card-content" style={{ padding: '20px' }}>
                                       <h5 style={{ color: '#333', fontWeight: '700', fontSize: '1.15rem', lineHeight: '1.4', margin: '0 0 10px 0' }}>
                                          {bw.blog_titulo}
                                       </h5>
                                       <div className="grey-text text-darken-2" style={{ fontSize: '0.9rem', lineHeight: '1.5' }} dangerouslySetInnerHTML={{ __html: bw.blog_texto_breve }}></div>
                                    </div>
                                    
                                    <div className="card-action" style={{ padding: '12px 20px', borderTop: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#fafafa' }}>
                                       <a className="modal-trigger light-blue-text text-accent-3" href="#modalBlog" onClick={() => handleModalBlog(bw.blog_id)} style={{ fontWeight: '600', fontSize: '0.95rem', cursor: 'pointer' }}>
                                          LEER MÁS
                                       </a>
                                       <span className="grey-text text-darken-1" style={{ fontSize: '0.85rem' }}>
                                          {bw.blog_fecha}
                                       </span>
                                    </div>
                                 </div>

                              </div>
                           )
                        })}
                     </div>
                     </div>
                  </div>

                  {/* COLUMNA DERECHA - PANEL LATERAL (AZUL INSTITUCIONAL) */}
                  <div className="col s12 m12 l4 xl4">
                     <div className='scroll-res'>
                        <div style={{ backgroundColor: '#039be5', borderRadius: '12px', padding: '25px 20px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }}>
                           
                           {/* NOTICIAS DESTACADAS */}
                           <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', marginBottom: '30px' }}>
                              {blogBlue?.map((bb, index) => {
                                 return (
                                    <div className="card" key={index} style={{ borderRadius: '10px', overflow: 'hidden', margin: 0, boxShadow: '0 4px 10px rgba(0,0,0,0.15)' }}>
                                       <div className="card-image" style={{ height: '150px', overflow: 'hidden', position: 'relative' }}>
                                          <img 
                                             src={`/app.latitud/img/blog/${bb.blog_img}`} 
                                             alt={bb.blog_titulo || "Blog"} 
                                             style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                          />
                                          <a className="btn-floating halfway-fab waves-effect waves-light light-blue accent-3 modal-trigger" href="#modalBlog" onClick={() => handleModalBlog(bb.blog_id)} style={{ right: '15px', bottom: '-20px', cursor: 'pointer' }}>
                                             <i className="material-icons">visibility</i>
                                          </a>
                                       </div>
                                       <div className="card-content" style={{ padding: '25px 15px 15px 15px' }}>
                                          <span className="card-title" style={{ fontSize: '1rem', fontWeight: '700', lineHeight: '1.4', color: '#333', marginBottom: '8px', display: 'block' }}>
                                             {bb.blog_titulo}
                                          </span>
                                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                             <span className="light-blue-text text-accent-3" style={{ fontSize: '0.75rem', fontWeight: '700', textTransform: 'uppercase' }}>
                                                {bb.blog_etiqueta}
                                             </span>
                                             <span className="grey-text text-darken-1" style={{ fontSize: '0.8rem' }}>
                                                {bb.blog_fecha}
                                             </span>
                                          </div>
                                       </div>
                                    </div>
                                 )
                              })}
                           </div>

                           {/* ACORDEÓN DE MESES */}
                           <div>
                              <h6 className="white-text" style={{ fontWeight: '700', marginBottom: '15px', fontSize: '1.1rem', letterSpacing: '0.5px' }}>
                                 Archivo por Meses
                              </h6>
                              <ul className="collapsible" style={{ borderRadius: '8px', overflow: 'hidden', border: 'none', boxShadow: 'none', margin: 0 }}>
                                 {blogMonth?.map((bm, index) => {
                                    return(
                                       <li key={index} style={{ marginBottom: '6px', borderRadius: '6px', overflow: 'hidden' }}>
                                          <div className="collapsible-header" style={{ backgroundColor: 'rgba(255, 255, 255, 0.95)', color: '#333', fontWeight: '600', border: 'none', padding: '10px 15px', minHeight: '45px' }}>
                                             <span>{bm.nombreMes}</span>
                                             <span className="new badge light-blue accent-3 white-text" data-badge-caption="" style={{ borderRadius: '4px', fontWeight: '600', margin: 0 }}>{bm.cantidad}</span>
                                          </div>
                                          <div className="collapsible-body" style={{ backgroundColor: 'rgba(255, 255, 255, 0.9)', border: 'none', padding: '10px 15px' }}>
                                             {bm?.news?.map((n, idx) => {
                                                return(
                                                <div key={idx} style={{ padding: '5px 0', borderBottom: idx < bm.news.length - 1 ? '1px solid #eee' : 'none' }}>
                                                   <a className="modal-trigger" href="#modalBlog" onClick={() => handleModalBlog(n.blog_id)} style={{ color: '#039be5', fontWeight: '500', fontSize: '0.85rem', lineHeight: '1.3', display: 'block', cursor: 'pointer' }}>
                                                      {n.blog_titulo}
                                                   </a>
                                                </div>
                                                )
                                             })}
                                          </div>
                                       </li>
                                    )
                                 })}
                              </ul>
                           </div>

                        </div>
                     </div>
                  </div>

               </div>
            </div>
         </div>
         <Modal modal={modal}/>
      </>
   )
}

export default Blog